module.exports = __webpack_public_path__ + "static/media/stargray.86a08780.svg";